import { defaultApiState } from '../api.state';

export const helloDnaProfileState = {
  apiState: {
    getHelloDnaProfiles: defaultApiState,
    getHelloDnaProfile: defaultApiState,
    updateHelloDnaProfile: defaultApiState,
    batchUpdateHelloDnaProfile: defaultApiState,
    uploadHelloDnaReport: defaultApiState,
  },
  helloDnaProfiles: [],
  helloDnaProfile: undefined,
};
